<template>
  <BaseDataIterator :service="fetchData" disable-search>
    <template #default="dataIteratorProps">
      <BaseDataTable :data="dataIteratorProps.data">
        <template #default="dataTableProps">
          <EmailCampaignListItem
            :email-campaign="dataTableProps.item"
            @deleted="dataIteratorProps.resetList"
          />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountEmailCampaignsClient } from '@/api/clients';
import EmailCampaignListItem from '@/components/EmailCampaign/EmailCampaignList/EmailCampaignListItem.vue';

export default {
  components: {
    EmailCampaignListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  methods: {
    fetchData(params) {
      return accountEmailCampaignsClient.list(this.accountId, {
        ...params,
        filter: {
          ...(params?.filter || {}),
          ...(this.since && this.until
            ? { created_between: [this.since, this.until].join(',') }
            : {}),
        },
        include: 'emailAddressesCount,emailAddressesSentCount,emailAddressesFailedCount',
      });
    },
  },
};
</script>
